// CardHeaderComponent.jsx
import React from "react";
import { CardHeader, Typography } from "@mui/material";

const CardHeaderComponent = ({ icon: Icon, title }) => {
  return (
    <CardHeader
      sx={{
        bgcolor: '#f8fafc',
        borderBottom: '1px solid #e2e8f0',
        py: 1.5,
        px: 2.5,
      }}
      title={
        <Typography
          sx={{
            fontWeight: 700,
            color: '#0f172a',
            fontSize: '0.95rem',
            letterSpacing: '0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          {Icon && <Icon color="primary" sx={{ fontSize: 20 }} />}
          {title}
        </Typography>
      }
    />
  );
};

export default CardHeaderComponent;